var map = {
	"./2-of-clubs.png": 6268,
	"./2-of-diamonds.png": 2176,
	"./2-of-hearts.png": 7468,
	"./2-of-spades.png": 636,
	"./3-of-clubs.png": 1632,
	"./3-of-diamonds.png": 7504,
	"./3-of-hearts.png": 588,
	"./3-of-spades.png": 2756,
	"./4-of-clubs.png": 1204,
	"./4-of-diamonds.png": 3120,
	"./4-of-hearts.png": 5736,
	"./4-of-spades.png": 2520,
	"./5-of-clubs.png": 9584,
	"./5-of-diamonds.png": 4088,
	"./5-of-hearts.png": 2956,
	"./5-of-spades.png": 860,
	"./6-of-clubs.png": 5188,
	"./6-of-diamonds.png": 3724,
	"./6-of-hearts.png": 2200,
	"./6-of-spades.png": 6304,
	"./7-of-clubs.png": 1796,
	"./7-of-diamonds.png": 1188,
	"./7-of-hearts.png": 9108,
	"./7-of-spades.png": 8116,
	"./8-of-clubs.png": 788,
	"./8-of-diamonds.png": 2444,
	"./8-of-hearts.png": 8004,
	"./8-of-spades.png": 3972,
	"./9-of-clubs.png": 6620,
	"./9-of-diamonds.png": 4712,
	"./9-of-hearts.png": 3199,
	"./9-of-spades.png": 3076,
	"./ace-of-clubs.png": 1196,
	"./ace-of-diamonds.png": 8120,
	"./ace-of-hearts.png": 52,
	"./ace-of-spades.png": 3160,
	"./back.png": 3520,
	"./jack-of-clubs.png": 7756,
	"./jack-of-diamonds.png": 1821,
	"./jack-of-hearts.png": 7308,
	"./jack-of-spades.png": 1844,
	"./king-of-clubs.png": 447,
	"./king-of-diamonds.png": 5812,
	"./king-of-hearts.png": 1024,
	"./king-of-spades.png": 1029,
	"./queen-of-clubs.png": 2352,
	"./queen-of-diamonds.png": 5852,
	"./queen-of-hearts.png": 8780,
	"./queen-of-spades.png": 6404,
	"./ten-of-clubs.png": 5580,
	"./ten-of-diamonds.png": 6048,
	"./ten-of-hearts.png": 1004,
	"./ten-of-spades.png": 8212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6568;